// extracted by mini-css-extract-plugin
module.exports = {"radio-label":"radioLabel___radio-label___BhxfU"};